<template>
    <div class="card border-light rounded-3 shadow-lg">
        <div class="card-body">
            <h2 class="card-title h4 mb-4 text-primary">Vos derniers questionnaires validés</h2>
            <div v-if="loading">Chargement...</div>
            <ul v-else-if="completeQuestionnaires && completeQuestionnaires.length" class="list-group list-group-flush">
                <li class="list-group-item d-none d-md-block">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <b>Nom de l'étude</b>
                        </div>
                        <div class="col-12 col-md-4">
                            <b>Date de validation</b>
                        </div>
                        <div class="col-12 col-md-2">
                            <b>Documents</b>
                        </div>
                    </div>
                </li>
                <li v-for="q in completeQuestionnaires" :key="q.id" class="list-group-item py-1">
                    <div class="row">
                        <div class="col-12 col-md-6 d-flex align-items-center">{{ q.title }}</div>
                        <div class="col-12 col-md-4 d-flex align-items-center">
                            <small class="mt-2 mt-md-0">{{ formatDate(q.cw_finishdate) }}</small>
                        </div>
                        <div
                            class="col-12 col-md-2 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                            <a href="#" @click="download(q.id)">Mes réponses</a>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else-if="completeQuestionnaires !== false">Vous n'avez aucun questionnaire validé récent.</div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import Tools from '../tools'

export default {
    name: 'CompleteQuestionnaires',
        data: () => ({
        cawiBaseUrl: process.env.VUE_APP_CAWI_BASE_URL,
        apiBaseUrl: process.env.VUE_APP_API_URL,
    }),
    mixins: [Tools],
    computed: {
        ...mapState(['loading', 'questionnaires']),
        ...mapGetters(['getUser']),
        completeQuestionnaires() {
            if (this.questionnaires !== null) {
                return this.questionnaires.filter((q) => !q.isAnalysis && q.complete && q.downloadable)
            }
            return false
        },
    },
    methods: {
        ...mapActions(['getDownloadToken', 'getDownloadCwtrack']),
        async download(qid) {
            this.alert = null
            const data = await this.getDownloadToken()
            const ret = await this.getDownloadCwtrack({token: data.token, qid})
            if (ret.CW_track) {
                const docUrl = `${this.cawiBaseUrl}/${qid}/${qid}.pdf?CW_track=${ret.CW_track}`
                this.alert = {
                    class: 'success',
                    message: `Votre document va s'ouvrir automatiquement.<br>Sinon, cliquez sur <a href="${docUrl}" onclick="window.open(this.href);return false">ce lien pour le télécharger</a>.`,
                }
                setTimeout(() => window.open(docUrl), 3000)
            } else {
                this.alert = { class: 'success', message: 'Une erreur est survenue.' }
            }
        }
    },
}
</script>
